exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.activos .estilo-grilla,\r\n.activos #gridComponent {\r\n  height: auto !important;\r\n  margin-bottom: 50px;\n}\r\n", ""]);

// exports
